import React, { Component } from "react";
import "./css/coverMobile.css";
import { Link } from "react-router-dom";

import imageBackground from "./scr/cover-mobile.jpg";
import imageStyle from "./scr/cover-style-mobile.png";

export default class coverMobile extends Component {
  render() {
    return (
      <div className="cover-mobile-main">
        <Link to="/home">
          <img
            className="cover-mobile-image"
            src={imageBackground}
            alt="imageBackground"
          />
        </Link>
        <div className="cover-mobile-footer">
          <img
            className="cover-mobile-style"
            src={imageStyle}
            alt="imageIcon"
          />
        </div>
      </div>
    );
  }
}
